__turbopack_context__.v({
  "brandChips": "styles-module-scss-module__4fZMNa__brandChips",
  "brandLink": "styles-module-scss-module__4fZMNa__brandLink",
  "brandRow": "styles-module-scss-module__4fZMNa__brandRow",
  "buyButton": "styles-module-scss-module__4fZMNa__buyButton",
  "buyButtonLabel": "styles-module-scss-module__4fZMNa__buyButtonLabel",
  "condition": "styles-module-scss-module__4fZMNa__condition",
  "couponCode": "styles-module-scss-module__4fZMNa__couponCode",
  "couponDetail": "styles-module-scss-module__4fZMNa__couponDetail",
  "couponExpiry": "styles-module-scss-module__4fZMNa__couponExpiry",
  "couponItem": "styles-module-scss-module__4fZMNa__couponItem",
  "couponToggle": "styles-module-scss-module__4fZMNa__couponToggle",
  "coupons": "styles-module-scss-module__4fZMNa__coupons",
  "description": "styles-module-scss-module__4fZMNa__description",
  "descriptionBlock": "styles-module-scss-module__4fZMNa__descriptionBlock",
  "descriptionHeader": "styles-module-scss-module__4fZMNa__descriptionHeader",
  "descriptionHeading": "styles-module-scss-module__4fZMNa__descriptionHeading",
  "descriptionPreview": "styles-module-scss-module__4fZMNa__descriptionPreview",
  "descriptionToggle": "styles-module-scss-module__4fZMNa__descriptionToggle",
  "details": "styles-module-scss-module__4fZMNa__details",
  "gallery": "styles-module-scss-module__4fZMNa__gallery",
  "galleryImage": "styles-module-scss-module__4fZMNa__galleryImage",
  "galleryTransform": "styles-module-scss-module__4fZMNa__galleryTransform",
  "galleryViewport": "styles-module-scss-module__4fZMNa__galleryViewport",
  "headerActions": "styles-module-scss-module__4fZMNa__headerActions",
  "headerButton": "styles-module-scss-module__4fZMNa__headerButton",
  "locationRow": "styles-module-scss-module__4fZMNa__locationRow",
  "locationText": "styles-module-scss-module__4fZMNa__locationText",
  "metadataHeading": "styles-module-scss-module__4fZMNa__metadataHeading",
  "metadataRow": "styles-module-scss-module__4fZMNa__metadataRow",
  "neutralChip": "styles-module-scss-module__4fZMNa__neutralChip",
  "price": "styles-module-scss-module__4fZMNa__price",
  "priceActions": "styles-module-scss-module__4fZMNa__priceActions",
  "priceRow": "styles-module-scss-module__4fZMNa__priceRow",
  "priceValue": "styles-module-scss-module__4fZMNa__priceValue",
  "pricingSummary": "styles-module-scss-module__4fZMNa__pricingSummary",
  "purchaseActions": "styles-module-scss-module__4fZMNa__purchaseActions",
  "reportButton": "styles-module-scss-module__4fZMNa__reportButton",
  "reportButtonWrapper": "styles-module-scss-module__4fZMNa__reportButtonWrapper",
  "saveButton": "styles-module-scss-module__4fZMNa__saveButton",
  "sizeInfo": "styles-module-scss-module__4fZMNa__sizeInfo",
  "sold": "styles-module-scss-module__4fZMNa__sold",
  "textAction": "styles-module-scss-module__4fZMNa__textAction",
  "timestamp": "styles-module-scss-module__4fZMNa__timestamp",
  "warningChip": "styles-module-scss-module__4fZMNa__warningChip",
  "zoomContainer": "styles-module-scss-module__4fZMNa__zoomContainer",
});
